import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { NotFoundPage } from "../http-errors";

export const NotFoundPageRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `${routes.page_not_found()}`,
    element: createElement(NotFoundPage),
    children: [...rest],
  };
};
